import { AxiosError } from 'axios';
import api from '../../../services/api';

export async function deleteFunctionRequest(id: number) {
	try {
		const response = await api.delete(`/function/${id}`);

		return response.data;
	} catch (error) {
		if (error instanceof AxiosError) {
			throw new Error(error.response?.data?.message);
		} else {
			throw new Error();
		}
	}
}
